// extracted by mini-css-extract-plugin
export default {"table-header":"table-header_table-header__6yVBl"};